export default {
    setUser(state, user) {
        state.user = user;
    },
    loader(state, payload) {
        state.loader = payload;
    },
    btnLoader(state, payload) {
        state.btnLoader = payload;
    },
    addToCart(state, item) {
        const exits = state.cart.find((record) => { return record.id === item.id })
        if (exits) {
            return
        }
        state.cart.push(item);
    },
    removeFromCart(state, id) {
        const item = state.cart.find((record) => { return record.id === id })
        return state.cart.splice(state.cart.indexOf(item), 1)
    },
    resetCart (state) {
        state.ordered = [ ...state.cart ]
        state.cart = []
      },
}